import { render, staticRenderFns } from "./role-information.html?vue&type=template&id=24c13616&"
import script from "./RoleInformation.vue?vue&type=script&lang=js&"
export * from "./RoleInformation.vue?vue&type=script&lang=js&"
import style0 from "./RoleInformation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports